import React from 'react'
import { getText } from '../../../../../internal/TextLabels'

export const renderBonusLabel = bonusChecks => {
  const badge = {
    color: '#fff',
    background: '#00cc00',
    width: 'auto',
    height: 'auto',
    margin: '2px',
    borderRadius: '50%',
    position: 'relative',
    top: '-10px',
    right: '0px',
    padding: '0px 5px 1px 5px',
    fontWeight: 'bold',
  }

  let nbrOfChecks = 0
  bonusChecks.forEach(c => {
    if (c.status === 'VALID') {
      nbrOfChecks += 1
    }
  })
  if (nbrOfChecks < 1) {
    return getText('payApply.paymentMethods.tabs.bonus')
  }
  return (
    <>
      {getText('payApply.paymentMethods.tabs.bonus')}
      <span style={badge}>{nbrOfChecks}</span>
    </>
  )
}
